module.exports = __webpack_public_path__ + "img/mobile-bar.c2d04be2.jpg";